
<h1 mat-dialog-title>{{'general.choixLangue' | translate}}</h1>
<mat-dialog-content>
    <p class="mb-1"> {{'front.modaleChoixLangue.texteChoixLangue' | translate}}</p>
        <mat-radio-group name="langue" id="langue" [(ngModel)]="langue">
            <mat-radio-button value="fr">{{ 'general.fr' | translate }}</mat-radio-button>
            <mat-radio-button class="ml-1" value="en">{{ 'general.en' | translate }}</mat-radio-button>
            <mat-radio-button class="ml-1" value="fr-en">{{ 'general.toutesLangues' | translate }}</mat-radio-button>
        </mat-radio-group>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false">{{'general.annuler' | translate}}</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="langue">{{'general.valider' | translate}}</button>
</mat-dialog-actions>
